import React from 'react';
import { Box, Typography } from '@mui/material';
import { StyledPaper } from '../shared/StyledComponents';

const UkioLaktacijuLentele = ({ pikas, reiksme90, santykis }) => {
  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <StyledPaper sx={{ gap: '20px' }}>
        <Box>
          <Typography>
            <b>{pikas.diena}</b>
          </Typography>
          <Typography>Laktacijos piko diena</Typography>
        </Box>
        <Box>
          <Typography>
            <b>{pikas.reiksme}</b>
          </Typography>
          <Typography>Rodiklio piko reikšmė</Typography>
        </Box>
        <Box>
          <Typography>
            <b>{reiksme90}</b>
          </Typography>
          <Typography>90-os dienos rodiklio reikšmė</Typography>
        </Box>
        <Box>
          <Typography>
            <b>{`${santykis} %`}</b>
          </Typography>
          <Typography>Rodiklio pokytis tarp 100d. ir 200d.</Typography>
        </Box>
      </StyledPaper>
    </Box>
  );
};

export default UkioLaktacijuLentele;
